/** Stock ledger vocabulary. `stock_movements` is append-only; balances live on products. */

export const STOCK_MOVEMENT_REASONS = {
  opening: "opening",
  reserve: "reserve",
  release: "release",
  writeOff: "write_off",
  adjust: "adjust",
} as const;

export type StockMovementReason = (typeof STOCK_MOVEMENT_REASONS)[keyof typeof STOCK_MOVEMENT_REASONS];

export const ALL_STOCK_MOVEMENT_REASONS: readonly StockMovementReason[] = [
  STOCK_MOVEMENT_REASONS.opening,
  STOCK_MOVEMENT_REASONS.reserve,
  STOCK_MOVEMENT_REASONS.release,
  STOCK_MOVEMENT_REASONS.writeOff,
  STOCK_MOVEMENT_REASONS.adjust,
];

export const STOCK_MOVEMENT_LABELS: Record<StockMovementReason, string> = {
  opening: "Opening balance",
  reserve: "Reserved",
  release: "Returned",
  write_off: "Written off",
  adjust: "Adjustment",
};

/** Reasons that give units back to the shelf. */
export const RESTOCKING_REASONS: readonly StockMovementReason[] = [
  STOCK_MOVEMENT_REASONS.release,
  STOCK_MOVEMENT_REASONS.adjust,
];

export const STOCK_MOVEMENT_DEFAULTS = {
  pageSize: 25,
  recentLimit: 10,
  maxNoteLength: 300,
} as const;
